<template>
  <div class="device-setting-info-component" :class="roomInfo.roomType">
    <div class="device-setting-info">
      <div class="device-set-info">
        <div class="device-set-info-header pc">
          <button class="back-btn" @click="handleClickBackBtn"></button>
        </div>
        <div class="device-set-info-body" v-if="isShowInfo">
          <div class="device-set-info-title-container" v-click-outside="onToggleInfo">
            <div class="device-set-info-room-type">
              <h2 class="device-set-info-room-type-text">{{ roomType }}</h2>
            </div>
            <div class="device-set-info-title-wrapper">
              <p class="device-set-info-title">{{ roomInfo.roomTitle }}</p>
            </div>
            <div v-if="noPermission">
              <p class="device-set-info-check">{{ $t("deviceSetting.info.waiting.error.permission") }}</p>
            </div>
            <div v-else-if="noManagerInRoom">
              <p class="device-set-info-check">{{ $t("deviceSetting.info.waiting.error.noManager") }}</p>
            </div>
            <div v-else-if="roomClosed">
              <p class="device-set-info-check">{{ $t("deviceSetting.info.waiting.error.closed") }}</p>
            </div>
            <div v-else-if="disapproved">
              <p class="device-set-info-check">{{ $t("deviceSetting.info.waiting.error.rejected") }}</p>
            </div>
            <div v-else class="device-set-info-check-wrapper">
              <p class="device-set-info-check roomDescription" v-html="$t('deviceSetting.info.waiting.deviceTest')"></p>
            </div>
            <div class="device-set-info-check-wrapper">
              <p class="device-set-info-check roomDescription" v-html="$t('deviceSetting.info.waiting.noMic')"></p>
            </div>
          </div>
        </div>
        <div class="device-set-info-footer pc">
          <div class="device-set-join-btn-wrapper">
            <button class="default-btn join-request-btn" @click="$emit('reqApproveJoin')">
              {{ (disapproved || noManagerInRoom || roomClosed) ? $t('deviceSetting.preview.toHome') : (enterRequested ? $t('deviceSetting.preview.join.requested') : $t('deviceSetting.preview.join.request')) }}
            </button>
            <a class="default-btn home" href="/service/room" target="_top">{{ $t("deviceSetting.preview.toHome") }}</a>
            <ul class="loading-obj-group">
              <li class="loading-obj obj-1"></li>
              <li class="loading-obj obj-2"></li>
              <li class="loading-obj obj-3"></li>
              <li class="loading-obj obj-4"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

import {roomWaitingEventApi} from "@/core/api/room.waiting.event.api";
import {roomWaitingApi} from "@/core/api/room.waiting.api";

import {Device} from "@/utils";

export default {
  name: 'DeviceSettingInfoWaiting',
  props: {
    roomInfo: Object,
    isShowInfo: Boolean,
  },
  data() {
    const events = {
      waiting_room_approved: e => {
        if (this.userId === e.data.userId) { // XXX 서버에서 대상을 찾아서 보내면 더 좋다.
          this.APPROVED();
        }
      },
      waiting_room_disapproved: e => {
        if (this.userId === e.data.userId) { // XXX 서버에서 대상을 찾아서 보내면 더 좋다.
          this.$alert(this.$t('deviceSetting.info.waiting.disapproved'));
          this.DISAPPROVED();
        }
      },
      waiting_room_noDevicePermission: e => {
        if (this.userId === e.userId) { // XXX 서버에서 대상을 찾아서 보내면 더 좋다.
          this.NO_PERMISSION();
        }
      },
      waiting_room_noManagerInRoom: e => {
        this.NO_MANAGER_IN_ROOM();
      },
      waiting_room_closed: e => {
        this.ROOM_CLOSED();
      },
      waiting_room_full: e => {
        this.$alert(this.$t('deviceSetting.info.waiting.full'))
      },
    }
    return {
      events,
    }
  },
  computed: {
    ...mapState('waitingRoom', [
      'waitingList',
      'enterRequested',
      'approved',
      'disapproved',
      'noPermission',
      'noManagerInRoom',
      'roomClosed'
      ]),
    ...mapGetters('roomSetting',['roomSetting']),
    roomType() {
      switch (this.roomInfo.roomType) {
        case 'conf':
          return this.$t('common.meeting');
        case 'edu':
          return this.$t('common.edu');
        case 'live':
        case 'wall':
          return this.$t('common.webinar');
        default:
          return '';
      }
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.unLoadEvent);
    this.currentUser().then(response => this.userId = response.data.user.userId);
    roomWaitingEventApi.addEventListeners(this.events, this);
  },
  beforeUnmount() {
    roomWaitingEventApi.removeEventListeners(this.events);
    window.removeEventListener('beforeunload', this.unLoadEvent);
  },
  methods: {
    unLoadEvent(e) {
      if (this.enterRequested && (!this.approved || !this.disapproved)) {
        this.leaveWaitingRoomApi({roomId: this.roomInfo.roomId})
      }
    },

    connect(enterParams) {
      roomWaitingApi.enter(enterParams);
    },

    disconnectWaitingRoomWs() {
      roomWaitingApi.disconnect("leaved");
    },

    reqApproveJoin(deviceSettings) {
      if (this.disapproved || this.noManagerInRoom || this.roomClosed) {
        window.history.back();
        return;
      }
      const roomId = this.roomInfo.roomId;
      const joinInfo = {
        roomId : roomId,
        cameraStatus: deviceSettings.video.deviceId ? 'on' : 'off',
        micStatus: deviceSettings.audio.deviceId ? 'on' : 'off',
        speakerStatus: deviceSettings.audiooutput.deviceId ? 'on' : 'off'
      }
      let userId;
      this.requestEnterApi(joinInfo)
          .then((data) => {
            this.ENTER_REQUESTED(true)
            this.userId = data.userId
          })
          .then(() => {
            this.connect({ roomId , userId: this.userId})
          })
          .catch(e => {
            switch (e.message) {
              case 'NONE_ROOM_SETTING':
                this.$alert({
                  text: this.$t('deviceSetting.info.waiting.noRoom'),
                  ok: async () => {
                    window.location.href = '/'
                  },
                  onlyOk: true
                })
                return;
              case 'NOT_ENABLE_WAITING_ROOM':
                this.$alert({
                  text: this.$t('deviceSetting.info.waiting.notAvailable'),
                  ok: async () => {
                    window.location.href = '/'
                  },
                  onlyOk: true
                })
                return;
              case 'NOT_EXISTS_MANAGER_ROLE':
                this.$alert({
                  text: this.$t('deviceSetting.info.waiting.noManager'),
                  ok: async () => {
                    window.location.href = '/'
                  },
                  onlyOk: true
                })
                return;
              case 'AlREADY_REQ_ENTER':
                this.$alert({
                  text: this.$t('deviceSetting.info.waiting.requested'),
                  onlyOk: true
                });
                return;
            }
          })
    },

    onToggleInfo() {
      if (!Device.isMobile()) {
        return;
      }
      this.$emit('update:isShowInfo', !this.isShowInfo);
    },
    handleClickBackBtn(){
      if (this.roomSetting.useClosingWindow) {
        window.close();
      } else {
        window.location.href = 'service/room';
      }
    },
    ...mapActions('waitingRoom',
        ['findAllByRoomIdApi', 'approveApi', 'disapproveApi', 'requestEnterApi',
         'disableWaitingRoomApi', 'leaveWaitingRoomApi', 'sendTestNoManagerInRoomApi', 'sendTestCloseRoomApi']),
    ...mapMutations('waitingRoom', [
      'CHANGE_ROLE_ID', 'ENTER_REQUESTED', 'ADD_WAITING_USER', 'APPROVAL', 'APPROVED',
      'DISAPPROVED', 'NO_PERMISSION', 'NO_MANAGER_IN_ROOM', 'ROOM_CLOSED',
    ]),
    ...mapActions('auth', ['currentUser']),
  },
  watch: {
    roomId(val) {
      this.findAllByRoomIdApi({roomId: val});
    },
    approved(val) {
      if (val) {
        this.disconnectWaitingRoomWs();
        this.$emit('reqJoin');
      }
    },
    disapproved(val) {
      if (val) {
        this.disconnectWaitingRoomWs();
      }
    },
    noManagerInRoom(val) {
      if (val) {
        this.disconnectWaitingRoomWs();
      }
    },
    roomClosed(val) {
      if (val) {
        this.disconnectWaitingRoomWs();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/roomType/conf/css/_deviceTestInfo';
</style>